import { useEffect, useState } from "react";

// Live mm:ss elapsed counter. While the game is in flight, ticks once per
// second from startedAt → now. Once completed, freezes at the canonical
// durationSeconds from the server (no client clock skew).
export function useElapsed(
  startedAt: string | null,
  completedAt: string | null,
  durationSeconds: number | null,
): { seconds: number; live: boolean } {
  const live = !!startedAt && !completedAt;
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!live) return;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [live]);

  if (completedAt && durationSeconds != null) {
    return { seconds: durationSeconds, live: false };
  }
  if (!startedAt) return { seconds: 0, live: false };
  const ms = Math.max(0, now - new Date(startedAt).getTime());
  return { seconds: Math.floor(ms / 1000), live };
}

export function formatDuration(seconds: number): string {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  if (m >= 60) {
    const h = Math.floor(m / 60);
    const rm = m % 60;
    return `${h}:${rm.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
  }
  return `${m}:${s.toString().padStart(2, "0")}`;
}
